/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Empty_Personal_TitleInputs */



/**
* | output |
* | --- |
* | "No practice conversation of your own yet" |
*
* @param {Practice_Empty_Personal_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_empty_personal_title = /** @type {((inputs?: Practice_Empty_Personal_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Empty_Personal_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nog geen eigen oefengesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pas encore d'entretien d'entraînement personnel")
	return /** @type {LocalizedString} */ ("No practice conversation of your own yet")
});